import { IconUserShield } from "@tabler/icons-react";
import { createElement } from "react";

import { CAPS } from "@/shell/roles";

import type { FeatureRoute, NavItem } from "../types";
import { StaffPage } from "./StaffPage";

export const routes: FeatureRoute[] = [
  { path: "/admin/staff", roles: CAPS.admin.staff, element: createElement(StaffPage) },
];

export const nav: NavItem[] = [
  { label: "Staff", path: "/admin/staff", icon: IconUserShield, surface: "admin", roles: CAPS.admin.staff },
];
